import HelpLayout from "@bit/ui-common.ui-components/ss-common-data/react/components/help/HelpLayout";

export default class Help extends React.Component {
    render() {
        const { portal, theme } = this.props;
        return (
            <div>
                <HelpLayout 
                    format='modal' 
                    portal={portal || 'c'} 
                    theme={theme || null}
                    defaultTab='FAQS'
                />
            </div>
        )
    }
}